export default __webpack_public_path__ + "static/media/Soulace_Floor_Plan.f88ba8a5.pdf";